export {
  Button,
  type ButtonProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Button';
